import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTienDoNhapDiemLopTinChiActionIds, ITienDoNhapDiemLopTinChiActionTypes } from "../../action-types/tong-hop/ITienDoNhapDiemLopTinChiActions";
import { tienDoNhapDiemApi } from "../../../api/tong-hop/tienDoNhapDiemApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ITienDoNhapDiemLopTinChiRequest } from "../../../model/request/tong-hop/ITienDoNhapDiemLopTinChiRequest";


export function* tienDoNhapDiemLopTinChiSaga(): any {
    yield takeLatest(eTienDoNhapDiemLopTinChiActionIds.THANH_PHAN_LOAD_START, loadLopTinChiWorker);
    yield takeLatest(eTienDoNhapDiemLopTinChiActionIds.THI_LOAD_START, loadThiWorker);
}


function* loadLopTinChiWorker(action: ITienDoNhapDiemLopTinChiActionTypes) {
    const request = action.payload as ITienDoNhapDiemLopTinChiRequest;
    const response: IBaseResponse = yield call(tienDoNhapDiemApi.SelectLopTinChiThanhPhan, request);
    if (response.is_success) {
        yield put(rootActions.tongHop.tienDoNhapDiemLopTinChi.THANH_PHAN_LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.tongHop.tienDoNhapDiemLopTinChi.THANH_PHAN_LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}

function* loadThiWorker(action: ITienDoNhapDiemLopTinChiActionTypes) {
    const request = action.payload as ITienDoNhapDiemLopTinChiRequest;
    const response: IBaseResponse = yield call(tienDoNhapDiemApi.SelectLopTinChiThi, request);
    if (response.is_success) {
        yield put(rootActions.tongHop.tienDoNhapDiemLopTinChi.THI_LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.tongHop.tienDoNhapDiemLopTinChi.THI_LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}